import { Bike, Building2, Car, Utensils } from "lucide-react";
import { useRef } from "react";

const opportunities = [
  {
    icon: <Bike size={48} />,
    label: "Become a courier",
    subtitle: "Deliver Orders and earn money",
  },
  {
    icon: <Utensils size={48} />,
    label: "Add a restaurant or store",
    subtitle: "Join Hareeng and reach more customers",
  },
  {
    icon: <Car size={48} />,
    label: "Sign up as a fleet owner",
    subtitle: "Add your fleet to Hareeng and boost your income",
  },
  {
    icon: <Building2 size={48} />,
    label: "Hareeng Business",
    subtitle: "Hareeng products and services for your business",
  },
];

export default function OpportunitiesSlider() {
  const sliderRef = useRef<HTMLDivElement>(null);

  // Simple scroll by 1 card left/right
  const scroll = (dir: "left" | "right") => {
    if (!sliderRef.current) return;
    const card = sliderRef.current.querySelector(".opportunity-card");
    if (!card) return;
    const cardWidth = (card as HTMLElement).offsetWidth + 16; // 16px gap
    sliderRef.current.scrollBy({
      behavior: "smooth",
      left: dir === "left" ? -cardWidth : cardWidth,
    });
  };

  return (
    <section className="relative mx-auto w-full max-w-7xl py-8">
      <div className="flex items-center">
        <button
          aria-label="Previous"
          className="mr-2 hidden rounded-full bg-base-100 p-2 shadow hover:bg-primary hover:text-white sm:inline-flex"
          onClick={() => scroll("left")}
          type="button"
        >
          <svg height={28} viewBox="0 0 24 24" width={28}>
            <path
              d="M15 19l-7-7 7-7"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        </button>
        <div
          className="flex gap-4 overflow-x-auto scroll-smooth pb-2"
          ref={sliderRef}
          style={{ scrollbarWidth: "none" }}
        >
          {opportunities.map((item, idx) => (
            <div
              className="opportunity-card flex min-w-[260px] max-w-xs flex-shrink-0 flex-col items-center justify-center rounded-2xl bg-base-200 p-4 shadow-lg dark:bg-base-300"
              key={item.label + idx}
            >
              <div className="mb-2 text-primary">{item.icon}</div>
              <div className="mb-1 break-words text-center text-lg font-bold text-base-content">
                {item.label}
              </div>
              <div className="text-center text-sm text-base-content opacity-70">
                {item.subtitle}
              </div>
            </div>
          ))}
        </div>
        <button
          aria-label="Next"
          className="ml-2 hidden rounded-full bg-base-100 p-2 shadow hover:bg-primary hover:text-white sm:inline-flex"
          onClick={() => scroll("right")}
          type="button"
        >
          <svg height={28} viewBox="0 0 24 24" width={28}>
            <path
              d="M9 5l7 7-7 7"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        </button>
      </div>
    </section>
  );
}
